import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { RootState } from 'store';

import AppBar from 'components/AppBar';
import EmptyList from 'components/EmptyList';
import Loader from 'components/Loader';
import { Desktop, Mobile } from 'components/Responsive';
import { CheckCircleIcon } from 'components/TripCard/styles';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { BranchCompany } from 'models/branchCompany';

import { Title, TitleContent, ImageContainer, Container, List, TitleSubContent, StatusText } from './styles';

interface Props {
  countries: any[];
  isLoading: boolean;
  onClick: (branchCompany: BranchCompany) => void;
}

const UserCountrySelectionComponent = ({ countries, isLoading, onClick }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory<{ completingCompanyProfile?: boolean }>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const toast = useToast();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isSaving, setIsSaving] = useState(false);
  const accountResult = useSelector((state: RootState) => state.user.accountResult);

  const handleNavigateHistory = () => {
    history.push('/dashboard');
  };

  const handleCountryFlag = (branchCompany: BranchCompany) => {
    switch (branchCompany.countryId) {
      case 'BR': {
        return 'images/flags/BR.png';
      }
      case 'CO': {
        return 'images/flags/CO.png';
      }
      case 'AR': {
        return 'images/flags/AR.png';
      }
      case 'UY': {
        return 'images/flags/UY.png';
      }
      case 'MX': {
        return 'images/flags/MX.png';
      }
    }

    return 'images/flags/CO.png';
  };

  return (
    <>
      <Mobile>
        <AppBar goBack={handleNavigateHistory} rightAction={() => history.push('/dashboard')}>
          <h5>{t('user-selection-country.title')}</h5>
        </AppBar>
      </Mobile>

      {isLoading || isSaving ? (
        <Loader fullScreen />
      ) : (
        <>
          <Desktop>
            <Title>{t('user-selection-country.title')}</Title>
          </Desktop>
          <List>
            {countries &&
              countries.map((branchCompany) => (
                <>
                  <Container initialColor="" finalColor="" onClick={() => onClick(branchCompany)}>
                    <ImageContainer>
                      <img alt="" src={handleCountryFlag(branchCompany)} />
                    </ImageContainer>
                    <TitleContent>
                      {t(`countries.${branchCompany.countryId}`)}
                      <TitleSubContent>
                        <>
                          {branchCompany.companyName}
                          {accountResult?.companyId === branchCompany.id && (
                            <>
                              <br />
                              <StatusText>
                                <CheckCircleIcon />
                                {t('user-selection-country.currentCompany')}
                              </StatusText>
                            </>
                          )}
                        </>
                      </TitleSubContent>
                    </TitleContent>
                  </Container>
                </>
              ))}
          </List>
          {!countries ||
            (countries.length === 0 && (
              <EmptyList
                grey
                paddingMessage={54}
                title={t('user-selection-country.emptySelection.title')}
                description={t('user-selection-country.emptySelection.text')}
                image="/images/group-2.svg"
                backgroundImage="/images/group-3.svg"
              />
            ))}
        </>
      )}
    </>
  );
};

export default UserCountrySelectionComponent;
